var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search_FILL0_wght400_GRAD0_opsz48",
    d: "M24.138,25.64l-3.9-3.93a7.6,7.6,0,0,1-2.413,1.4,8.53,8.53,0,0,1-2.931.5A8.583,8.583,0,0,1,8.586,21.02,8.507,8.507,0,0,1,6,14.778,8.507,8.507,0,0,1,8.586,8.536,8.543,8.543,0,0,1,14.861,5.95a8.446,8.446,0,0,1,6.223,2.586,8.536,8.536,0,0,1,2.569,6.242,8.6,8.6,0,0,1-.483,2.862,8.754,8.754,0,0,1-1.448,2.586l3.968,3.93a.9.9,0,0,1,.31.707,1.072,1.072,0,0,1-.345.776,1.082,1.082,0,0,1-1.517,0Zm-9.278-4.1a6.451,6.451,0,0,0,4.758-1.983,6.54,6.54,0,0,0,1.965-4.776A6.54,6.54,0,0,0,19.618,10a6.451,6.451,0,0,0-4.758-1.983A6.548,6.548,0,0,0,10.051,10a6.511,6.511,0,0,0-1.982,4.776,6.511,6.511,0,0,0,1.982,4.776A6.548,6.548,0,0,0,14.861,21.538Z",
    transform: "translate(-6 -5.95)",
    fill: "#ababab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.558918dec0d53f42bf7efeb1718b1aaa.svg";
export { ForwardRef as ReactComponent };